// Pro-Stück-Preis Berechnung für Shopify
// Optimiert für Sami Wholesale Integration
// Version: Bereinigt und korrigiert für korrekte Preiswahl

(function() {
  'use strict';

  // Fehlerhafte querySelector Aufrufe abfangen
  const originalQuerySelector = document.querySelector;
  document.querySelector = function(selector) {
    if (selector === '., #' || selector === ',' || selector === '#') {
      return null;
    }
    return originalQuerySelector.apply(this, arguments);
  };

  // Globale Variablen um Endlos-Schleifen zu verhindern
  let isUpdating = false;
  let lastUpdateTime = 0;
  const UPDATE_COOLDOWN = 300; // Mindestens 300ms zwischen Updates

  // Definition von initAllPerPiecePrices
  function initAllPerPiecePrices() {
    const containers = document.querySelectorAll('.per-piece-price-container');
    containers.forEach((container, index) => {
      container.dataset.containerIndex = index;
      initPerPiecePrice(container);
    });
  }

  // Definition von initPerPiecePrice
  function initPerPiecePrice(container) {
    const productId = container.dataset.productId;
    const piecesCount = parseInt(container.dataset.piecesCount);

    if (!productId || !piecesCount || piecesCount <= 1) {
      return;
    }

    let productElement = container.closest('.grid__item');
    if (!productElement) {
      productElement = container.closest('[data-product-id]');
    }
    if (!productElement) {
      productElement = container.parentElement;
    }

    if (!productElement || productElement === container) {
      console.error(`[Container ${container.dataset.containerIndex}, Produkt ${productId}] initPerPiecePrice: productElement ist fehlerhaft. productElement:`, productElement);
      return;
    }

    function formatPrice(priceInCents) {
      const euros = priceInCents / 100;
      if (window.perPiecePriceConfig && window.perPiecePriceConfig.currencyCodeEnabled) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(euros);
      } else {
        return euros.toFixed(2).replace('.', ',') + ' €';
      }
    }

    function updatePerPiecePrice() {
      const now = Date.now();
      if (isUpdating && (now - lastUpdateTime) < UPDATE_COOLDOWN) {
        return;
      }
      isUpdating = true;
      lastUpdateTime = now;

      let currentPrice = null;
      let priceElement = null;
      // const containerIndexFromDataset = container.dataset.containerIndex; // Already available via container.dataset.containerIndex

      if (!productElement) {
        console.error(`[Container ${container.dataset.containerIndex}, Produkt ${productId}] updatePerPiecePrice: productElement ist null oder undefined.`);
        isUpdating = false;
        return;
      }

     // --- MODIFIED PRICE SELECTION LOGIC (THEME FIRST, SAMITA SAFE) ---

const isVisible = (el) => {
  if (!el) return false;
  const cs = window.getComputedStyle(el);
  if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
  if (el.offsetParent === null && cs.position !== 'fixed') return false;
  return true;
};

const pickThemePrice = (root) => {
  if (!root) return null;

  // 1) echter Sale-Preis (nicht durchgestrichen)
  let nodes = Array.from(
    root.querySelectorAll('.price__sale .price-item--sale:not(s)')
  ).filter(isVisible);
  if (nodes.length) return nodes[nodes.length - 1];

  // 2) regulärer Preis
  nodes = Array.from(
    root.querySelectorAll('.price__regular .price-item--regular:not(s)')
  ).filter(isVisible);
  if (nodes.length) return nodes[nodes.length - 1];

  // 3) Fallbacks
  nodes = Array.from(root.querySelectorAll('.price-item--last:not(s)')).filter(isVisible);
  if (nodes.length) return nodes[nodes.length - 1];

  nodes = Array.from(root.querySelectorAll('.price-item')).filter(isVisible);
  if (nodes.length) return nodes[nodes.length - 1];

  return null;
};

// Card-Root für diese Instanz
let cardRoot =
  container.closest('[data-samitaws-handle], [data-sami-handle]') ||
  container.closest('.card, .card-wrapper, .product-card, .grid__item') ||
  productElement;

// 1) NÄCHSTER .price-BLOCK in dieser Card (Sibling rückwärts, dann Parent, dann Card-Root)
let priceContainer = null;
let sib = container.previousElementSibling;
while (sib && !(sib.classList && sib.classList.contains('price'))) {
  sib = sib.previousElementSibling;
}
if (sib) priceContainer = sib;

if (!priceContainer && container.parentElement) {
  priceContainer = container.parentElement.querySelector(':scope > .price');
}
if (!priceContainer && cardRoot) {
  priceContainer = cardRoot.querySelector('.price');
}

// 2) THEME-Preis priorisieren (funktioniert auch, wenn Samita die Theme-Preise überschreibt)
priceElement = pickThemePrice(priceContainer) || pickThemePrice(cardRoot);

// 3) FALLBACK: Samita – aber **ohne** Compare-At-Price
if (!priceElement && cardRoot) {
  const samiRoot = cardRoot.querySelector('[data-sami-price-container]') || cardRoot;

  // Kandidaten: Samita-Preis-Knoten, aber keine Compare-At-Knoten, nicht <s>, sichtbar
  let samiCandidates = Array.from(
    samiRoot.querySelectorAll('[samitaws-product-price], [samitaWS-product-price]')
  )
    .filter(isVisible)
    .filter(n => !n.matches('[samitaws-product-compare-at-price], [samitaWS-product-compare-at-price]'))
    .filter(n => n.tagName.toLowerCase() !== 's');

  // Bevorzuge markierte Sale-/Regular-Klassen, sonst letzter sichtbarer
  let pick = samiCandidates.filter(n => n.classList.contains('price-item--sale'));
  if (!pick.length) pick = samiCandidates.filter(n => n.classList.contains('price-item--regular'));
  if (!pick.length) pick = samiCandidates;
  if (pick.length) priceElement = pick[pick.length - 1];
}

// --- END OF MODIFIED PRICE SELECTION LOGIC ---




      if (priceElement && priceElement.textContent) {
        const priceText = priceElement.textContent.trim();
        // This regex finds all occurrences of numbers (possibly with . or ,) followed by "€"
        const allPrices = priceText.match(/(\d+[.,]?\d*)\s*€/g);

        if (allPrices && allPrices.length > 0) {
          // Assume the last price found in the string is the actual current price
          // (e.g., if text is "Was 30,90 €, Now 19,90 €", this gets "19,90 €")
          const lastPriceString = allPrices[allPrices.length - 1];
          const lastPriceMatch = lastPriceString.match(/(\d+[.,]?\d*)/);

          if (lastPriceMatch && lastPriceMatch[1]) {
            currentPrice = parseFloat(lastPriceMatch[1].replace(',', '.'));
          }
        }

        if (currentPrice && currentPrice > 0) {
          const priceInCents = Math.round(currentPrice * 100);
          const perPiecePriceCents = Math.round(priceInCents / piecesCount);
          const perPieceElement = container.querySelector('.per-piece-amount');
          if (perPieceElement) {
            const newPrice = formatPrice(perPiecePriceCents);
            if (perPieceElement.textContent !== newPrice) {
              perPieceElement.textContent = newPrice;
              // console.log(`Pro-Stück-Preis aktualisiert: ${currentPrice}€ / ${piecesCount} = ${newPrice} für Container ${container.dataset.containerIndex}`);
            }
          }
        } else {
          // console.warn(`[Container ${container.dataset.containerIndex}, Produkt ${productId}] updatePerPiecePrice: Konnte keinen gültigen currentPrice aus priceElement extrahieren. priceElement Text: "${priceText}", priceElement:`, priceElement);
        }
      } else {
        // console.warn(`[Container ${container.dataset.containerIndex}, Produkt ${productId}] updatePerPiecePrice: priceElement nicht gefunden oder ohne textContent.`);
      }
      setTimeout(() => { isUpdating = false; }, 50);
    }

    document.addEventListener('sami:priceUpdated', function(e) { setTimeout(updatePerPiecePrice, 100); });
    document.addEventListener('sami:customerChanged', function(e) { setTimeout(updatePerPiecePrice, 100); });
    document.addEventListener('variant:change', function(e) {
      const eventForm = e.target.closest('form');
      const parentForm = container.closest('form');
      if (eventForm === parentForm) { setTimeout(updatePerPiecePrice, 100); }
    });

    const form = container.closest('form');
    if (form) {
      form.addEventListener('change', function(e) {
        if (e.target.name === 'id' || e.target.dataset.productVariant) { setTimeout(updatePerPiecePrice, 100); }
      });
    }

    let observerTimeout;
    const observer = new MutationObserver(function(mutations) {
      if (isUpdating) return;
      let shouldUpdate = false;
      for (let mutation of mutations) {
        if (mutation.target === container || container.contains(mutation.target)) continue;
        const target = mutation.target;
        if (mutation.type === 'characterData') {
          const parent = target.parentElement;
          if (parent && (parent.hasAttribute('samitaws-product-price') || parent.classList.contains('price-item'))) {
            shouldUpdate = true; break;
          }
        }
        if (mutation.type === 'attributes') {
          if (target.hasAttribute('samitaws-product-price') || target.classList.contains('price-item')) {
            shouldUpdate = true; break;
          }
        }
      }
      if (shouldUpdate) {
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(() => {
          updatePerPiecePrice();
        }, 100);
      }
    });

    if (productElement) {
      const priceAreaToObserve = productElement.querySelector('.price') || productElement;
      observer.observe(priceAreaToObserve, {
        childList: true, subtree: true, characterData: true, attributes: true,
        attributeFilter: ['style', 'class', 'samitaws-product-price', 'data-price-element']
      });
    } else {
      // console.error(`[Container ${container.dataset.containerIndex}] Kein productElement für MutationObserver vorhanden.`);
    }

    if (productElement) {
      setTimeout(() => updatePerPiecePrice(), 50); // Initial quick update
      const localContainerIndex = parseInt(container.dataset.containerIndex, 10) || 0;
      const delayBase = localContainerIndex * 200; // Stagger updates for multiple products
      setTimeout(() => updatePerPiecePrice(), 500 + delayBase);  // Reduced initial delays
      setTimeout(() => updatePerPiecePrice(), 1500 + delayBase);
      // setTimeout(() => updatePerPiecePrice(), 3000 + delayBase); // Kept one longer delay just in case
    } else {
      // console.error(`[Container ${container.dataset.containerIndex}] Initiale/verzögerte Berechnung übersprungen, da productElement fehlt.`);
    }
  }

  window.updateAllPerPiecePrices = function() {
    document.dispatchEvent(new CustomEvent('sami:priceUpdated', { detail: { forceUpdate: true } }));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPerPiecePrices);
  } else {
    initAllPerPiecePrices();
  }

})();
